module.exports = __webpack_public_path__ + "static/media/AssetMarketplace App overview - GBR Network - 08-10-2024 N.2f229eb0.gif";